<template>
  <div>
    <!-- front card -->
    <div
      :class="
        sideBySide ? 'icard-container side-by-side' : 'icard-container stacked'
      "
      v-for="(stud_data, ind) in icard_data"
      :key="ind"
      style="background-color: white; font-weight: 1000; font-family: Tahoma"
    >
      <div v-if="icard_data != ''" style="width: 29.2rem">
        <v-row>
          <v-col cols="12" sm="2" md="2" class="pb-0 pt-0">
            <img :src="common_data.logo" width="90" height="70" alt="logo" />
          </v-col>
          <v-col cols="12" sm="10" md="10" class="pb-0 pt-2">
            <div
              class="text-right"
              style="font-weight: bold; line-height: 110%"
            >
              <div class="text-purple" style="font-size: 12px">
                Pimpri Chinchwad Education Trust's
              </div>
              <div class="text-maroon" style="font-size: 16px">
                S.B. PATIL PUBLIC SCHOOL, RAVET, PUNE
              </div>
              <div class="text-purple" style="font-size: 12px">
                CBSE Affiliation No.: 1130534
              </div>
              <div class="text-purple" style="font-size: 12px; margin-top: -5px;">
                NABET Accredited, QS I-GAUGE Diamond+ Rated
              </div>
              <div class="text-purple pb-1" style="font-size: 12px; white-space: nowrap; letter-spacing: -0.2px; margin-top: -5px; width: 100%;">
                 British Council Recognition of International Dimension in Schools
              </div>
            </div>
          </v-col>
        </v-row>
        <div style="height: 5px; background-color: maroon; width: 102%; margin-top: -6px;"></div>
        <v-img style="height: 122px" :src="common_data.watermark_back">
          <v-row justify="center">
            <v-col
              cols="12"
              sm="3"
              md="3"
              class="d-flex flex-column align-center pt-1 pl-5 pr-0 pb-0"
            >
              <img
                :src="stud_data.mphoto"
                style="margin-right: -18px"
                class="box1"
              />
              <span class="text-maroon pl-2" style="font-size: 13px"
                >Mother</span
              >
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="3"
              style="margin-right: 2px; margin-left: 3px"
              class="d-flex flex-column align-center pt-1 pr-0 pb-0 pl-0"
            >
              <img :src="stud_data.fphoto" class="box1" />
              <span class="text-maroon" style="font-size: 13px">Father</span>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="3"
              style="margin-left: -18px; margin-right: -10px"
              class="d-flex flex-column align-center pt-1 pr-0 pb-0 pl-0"
            >
              <img :src="stud_data.gphoto1" class="box1" />
              <span class="text-maroon" style="font-size: 13px">Guardian 1</span>
            </v-col>
            <v-col
              cols="12"
              sm="3"
              md="3"
              class="d-flex flex-column align-center pt-1 pl-0 pb-0"
            >
              <img :src="stud_data.gphoto2" class="box1" />
              <span class="text-maroon" style="font-size: 13px"
                >Guardian 2</span
              >
            </v-col>
          </v-row>
        </v-img>
        <div class="pl-4 pt-1" style="font-size: 15px">
          {{ stud_data.name }}
        </div>

        <v-row style="font-size: 12px; position: relative;">
          <v-col
            cols="12"
            sm="5"
            md="5"
            class="pt-0 pr-0"
            style="padding-left: 27px"
            >
            <span
              >{{ stud_data.mother_mobile_no }} /
              {{ stud_data.father_mobile_no }}</span
            >
          </v-col>
          <div
              style="
                position: absolute;
                left: 290px;
                top: -12px;
                width: 50px;
                height: 50px;
                z-index: 2;
              "
            >
              <img
                src="https://vgespl-sbpps.s3.ap-south-1.amazonaws.com/Role_link_icons/sbpps/1/rids_year_cmyk(14-08-2025)-np-02(1)(1)99rpcrtq8n.png"
                alt="Recognition"
                style="
                  width: 50px;
                  height: 50px;
                  object-fit: contain;
                  display: block;
                "
              />
          </div>
          <v-col
            cols="12"
            sm="2"
            md="2"
            class="pt-0 pb-0"
            style="margin-top: -15px;margin-left:170px;"
          >
            <img
              :src="common_data.sign"
              style="margin-left: 6px; margin-top: 2px"
              width="82"
              height="25"
              alt="sign"
            />
            <div style="margin-top: -3px" class="pl-1">PRINCIPAL</div>
          </v-col>
        </v-row>
        <div style="font-size: 12px;margin-left: 15px; margin-top: -7px">
        <input type="checkbox"/> Parent
            <input type="checkbox" style="margin-left: 10px"/> Van
            <input type="checkbox" style="margin-left: 10px"/> Cycle 
            <input type="checkbox"style="margin-left: 10px" /> Bus
          </div>

        <div style="height: 5px; background-color: maroon; width: 102%;margin-top:4px;"></div>
      </div>
      <!-- back card -->
      <div class="pagebreak" v-if="icard_data != ''" style="width: 29.2rem">
        <v-row>
          <v-col cols="12" sm="2" md="2" class="pr-0 pt-1 pl-6">
            <span class="text-purple" style="font-size: 12px">Address :</span>
          </v-col>
          <v-col
            cols="12"
            sm="10"
            md="10"
            class="pl-1 pt-1 pb-1"
            style="height: 55px"
          >
            <span style="font-size: 12px">{{ stud_data.stud_address }}</span>
          </v-col>
        </v-row>
        <div style="height: 5px; background-color: maroon; width: 102%"></div>
        <v-row>
          <v-col cols="12" sm="8" md="8" class="pb-0 pt-2">
            <v-row justify="center" class="text-maroon">Declaration</v-row>
            <div style="
                  font-size: 13px;
                  padding-left: 15px;
                  margin-top: 1px;
                  text-align: justify;
                  text-justify: inter-word;
                  line-height: 1.15;
                ">
              We, the parents of
              <span class="text-maroon">{{ stud_data.name }}</span>
              authorise the person presenting this Parent ID Card to collect the student pictured herein, 
                subject to verification of their identity by the school authorities.
            </div>
          </v-col>
          <v-col
            cols="12"
            sm="3"
            md="3"
            class="d-flex flex-column align-center pb-0"
            style="position: relative; top: 13px;"
          >
            <img :src="stud_data.profile_photo_path" class="box1" />
            <span class="text-maroon" style="font-size: 13px">Student</span>
          </v-col>
        </v-row>
        <v-row justify="center">
          <barcode
            height="12"
            width="2"
            font-size="15px"
            v-model="stud_data.prn"
            v-bind:value="stud_data.prn"
          >
          </barcode>
        </v-row>
        <div style="height: 5px; background-color: maroon; width: 102%"></div>
        <v-row justify="center">
          <span style="font-size: 12px; padding-left: 5px; padding-top: 2px">{{
            common_data.school_address
          }}</span
          ><br />
          <span
            style="
              font-size: 9px;
              text-align: center;
              margin-top: -2px;
              margin-bottom: 5px;
              padding-left: 5px;
            "
            >Contact No. {{ common_data.school_contact }},
            {{ common_data.website }}, {{ common_data.school_email }}</span
          >
        </v-row>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import VueBarcode from "vue-barcode";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  props: {
    sideBySide: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    barcode: VueBarcode,
  },
  data: () => ({
    snackbar_msg: "",
    color: "",
    snackbar: false,
    stud_data: null,
    comp_load: false,
    icard_data: [],
    prn: null
  }),
  mounted() {
    this.prn = JSON.parse(localStorage.getItem("prn"));
    this.onload();
  },
  methods: {
    onload() {
      const data = {
        learners: this.prn,
        for: "specific",
        usertype: "Parent",
      };
      axios
        .post("/Icard/getIcardSpecificStudentsforSbpps", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.icard_data = res.data.icard_data;
            this.common_data = res.data.common_data;
          } else if (res.data.flag == "No") {
            this.showSnackbar("red", res.data.snackbar);
          }
        })
        .catch((error) => {
          alert("Somthing went wrong!!!");
        })
        .finally(() => {
          this.comp_load = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
  },
};
</script>
<style scoped>
.icard-container.side-by-side {
  display: flex;
  flex-direction: row;
  gap: 50px;
}

.icard-container.stacked {
  display: flex;
  flex-direction: column;
}
@media (max-width: 600px) {
  .icard-container.side-by-side {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
}
.colorcss {
  margin-right: -22px;
  margin-left: 2px;
}
.barcode {
  margin-top: -1px;
  margin-bottom: -2px;
}
.text-maroon {
  color: maroon;
}
.text-purple {
  color: indigo;
}
.box1 {
  border: 2px solid black;
  width: 99px;
  height: 99px;
  text-align: center;
}
@media print {
  header,
  footer,
  nav,
  date {
    display: none !important;
  }

  .no-display,
  .v-input__control,
  input[type="button"],
  input[type="submit"],
  input[type="reset"],
  #v-card {
    display: none !important;
    font-size: x-large !important;
  }

  v-card {
    border: none !important;
  }

  * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .pagebreak {
    page-break-before: always !important;
  }

  .logo {
    height: 60px !important;
    width: 80px !important;
    margin-left: 10px !important;
  }

  @page {
    margin: 00mm;
    size: 85mm 52mm;
    margin-top: -0.08mm;
  }
  .barcode {
    margin-top: -1px;
    margin-bottom: -5px;
  }
}
</style>
